/* eslint-disable */
// source: company.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.revenues.private.company.GeTrialBalanceResponse', null, global);
goog.exportSymbol('proto.revenues.private.company.GetMonthsRevenueRequest', null, global);
goog.exportSymbol('proto.revenues.private.company.GetMonthsRevenueResponse', null, global);
goog.exportSymbol('proto.revenues.private.company.GetTrialBalanceRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.revenues.private.company.GetMonthsRevenueRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.revenues.private.company.GetMonthsRevenueRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.revenues.private.company.GetMonthsRevenueRequest.displayName = 'proto.revenues.private.company.GetMonthsRevenueRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.revenues.private.company.GetMonthsRevenueResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.revenues.private.company.GetMonthsRevenueResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.revenues.private.company.GetMonthsRevenueResponse.displayName = 'proto.revenues.private.company.GetMonthsRevenueResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.revenues.private.company.GetTrialBalanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.revenues.private.company.GetTrialBalanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.revenues.private.company.GetTrialBalanceRequest.displayName = 'proto.revenues.private.company.GetTrialBalanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.revenues.private.company.GeTrialBalanceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.revenues.private.company.GeTrialBalanceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.revenues.private.company.GeTrialBalanceResponse.displayName = 'proto.revenues.private.company.GeTrialBalanceResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.revenues.private.company.GetMonthsRevenueRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.revenues.private.company.GetMonthsRevenueRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.revenues.private.company.GetMonthsRevenueRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.revenues.private.company.GetMonthsRevenueRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    year: jspb.Message.getFieldWithDefault(msg, 2, 0),
    month: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.revenues.private.company.GetMonthsRevenueRequest}
 */
proto.revenues.private.company.GetMonthsRevenueRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.revenues.private.company.GetMonthsRevenueRequest;
  return proto.revenues.private.company.GetMonthsRevenueRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.revenues.private.company.GetMonthsRevenueRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.revenues.private.company.GetMonthsRevenueRequest}
 */
proto.revenues.private.company.GetMonthsRevenueRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setYear(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMonth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.revenues.private.company.GetMonthsRevenueRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.revenues.private.company.GetMonthsRevenueRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.revenues.private.company.GetMonthsRevenueRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.revenues.private.company.GetMonthsRevenueRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getYear();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getMonth();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 company_id = 1;
 * @return {number}
 */
proto.revenues.private.company.GetMonthsRevenueRequest.prototype.getCompanyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.revenues.private.company.GetMonthsRevenueRequest} returns this
 */
proto.revenues.private.company.GetMonthsRevenueRequest.prototype.setCompanyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 year = 2;
 * @return {number}
 */
proto.revenues.private.company.GetMonthsRevenueRequest.prototype.getYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.revenues.private.company.GetMonthsRevenueRequest} returns this
 */
proto.revenues.private.company.GetMonthsRevenueRequest.prototype.setYear = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 month = 3;
 * @return {number}
 */
proto.revenues.private.company.GetMonthsRevenueRequest.prototype.getMonth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.revenues.private.company.GetMonthsRevenueRequest} returns this
 */
proto.revenues.private.company.GetMonthsRevenueRequest.prototype.setMonth = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.revenues.private.company.GetMonthsRevenueResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.revenues.private.company.GetMonthsRevenueResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.revenues.private.company.GetMonthsRevenueResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.revenues.private.company.GetMonthsRevenueResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    isInTrial: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    trialExpiredOnDate: (f = msg.getTrialExpiredOnDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    totalRevenue: jspb.Message.getFieldWithDefault(msg, 3, 0),
    billsbyFeePercentage: jspb.Message.getFieldWithDefault(msg, 4, 0),
    trialLimit: jspb.Message.getFieldWithDefault(msg, 5, 0),
    billsbyFeeAmount: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.revenues.private.company.GetMonthsRevenueResponse}
 */
proto.revenues.private.company.GetMonthsRevenueResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.revenues.private.company.GetMonthsRevenueResponse;
  return proto.revenues.private.company.GetMonthsRevenueResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.revenues.private.company.GetMonthsRevenueResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.revenues.private.company.GetMonthsRevenueResponse}
 */
proto.revenues.private.company.GetMonthsRevenueResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsInTrial(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTrialExpiredOnDate(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalRevenue(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBillsbyFeePercentage(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTrialLimit(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBillsbyFeeAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.revenues.private.company.GetMonthsRevenueResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.revenues.private.company.GetMonthsRevenueResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.revenues.private.company.GetMonthsRevenueResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.revenues.private.company.GetMonthsRevenueResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsInTrial();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getTrialExpiredOnDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTotalRevenue();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getBillsbyFeePercentage();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getTrialLimit();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getBillsbyFeeAmount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional bool is_in_trial = 1;
 * @return {boolean}
 */
proto.revenues.private.company.GetMonthsRevenueResponse.prototype.getIsInTrial = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.revenues.private.company.GetMonthsRevenueResponse} returns this
 */
proto.revenues.private.company.GetMonthsRevenueResponse.prototype.setIsInTrial = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp trial_expired_on_date = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.revenues.private.company.GetMonthsRevenueResponse.prototype.getTrialExpiredOnDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.revenues.private.company.GetMonthsRevenueResponse} returns this
*/
proto.revenues.private.company.GetMonthsRevenueResponse.prototype.setTrialExpiredOnDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.revenues.private.company.GetMonthsRevenueResponse} returns this
 */
proto.revenues.private.company.GetMonthsRevenueResponse.prototype.clearTrialExpiredOnDate = function() {
  return this.setTrialExpiredOnDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.revenues.private.company.GetMonthsRevenueResponse.prototype.hasTrialExpiredOnDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 total_revenue = 3;
 * @return {number}
 */
proto.revenues.private.company.GetMonthsRevenueResponse.prototype.getTotalRevenue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.revenues.private.company.GetMonthsRevenueResponse} returns this
 */
proto.revenues.private.company.GetMonthsRevenueResponse.prototype.setTotalRevenue = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 billsby_fee_percentage = 4;
 * @return {number}
 */
proto.revenues.private.company.GetMonthsRevenueResponse.prototype.getBillsbyFeePercentage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.revenues.private.company.GetMonthsRevenueResponse} returns this
 */
proto.revenues.private.company.GetMonthsRevenueResponse.prototype.setBillsbyFeePercentage = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 trial_limit = 5;
 * @return {number}
 */
proto.revenues.private.company.GetMonthsRevenueResponse.prototype.getTrialLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.revenues.private.company.GetMonthsRevenueResponse} returns this
 */
proto.revenues.private.company.GetMonthsRevenueResponse.prototype.setTrialLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 billsby_fee_amount = 6;
 * @return {number}
 */
proto.revenues.private.company.GetMonthsRevenueResponse.prototype.getBillsbyFeeAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.revenues.private.company.GetMonthsRevenueResponse} returns this
 */
proto.revenues.private.company.GetMonthsRevenueResponse.prototype.setBillsbyFeeAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.revenues.private.company.GetTrialBalanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.revenues.private.company.GetTrialBalanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.revenues.private.company.GetTrialBalanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.revenues.private.company.GetTrialBalanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    companyId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.revenues.private.company.GetTrialBalanceRequest}
 */
proto.revenues.private.company.GetTrialBalanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.revenues.private.company.GetTrialBalanceRequest;
  return proto.revenues.private.company.GetTrialBalanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.revenues.private.company.GetTrialBalanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.revenues.private.company.GetTrialBalanceRequest}
 */
proto.revenues.private.company.GetTrialBalanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCompanyId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.revenues.private.company.GetTrialBalanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.revenues.private.company.GetTrialBalanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.revenues.private.company.GetTrialBalanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.revenues.private.company.GetTrialBalanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyId();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 company_id = 1;
 * @return {number}
 */
proto.revenues.private.company.GetTrialBalanceRequest.prototype.getCompanyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.revenues.private.company.GetTrialBalanceRequest} returns this
 */
proto.revenues.private.company.GetTrialBalanceRequest.prototype.setCompanyId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.revenues.private.company.GeTrialBalanceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.revenues.private.company.GeTrialBalanceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.revenues.private.company.GeTrialBalanceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.revenues.private.company.GeTrialBalanceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    isInTrial: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    trialBalance: jspb.Message.getFieldWithDefault(msg, 2, 0),
    trialLimit: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.revenues.private.company.GeTrialBalanceResponse}
 */
proto.revenues.private.company.GeTrialBalanceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.revenues.private.company.GeTrialBalanceResponse;
  return proto.revenues.private.company.GeTrialBalanceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.revenues.private.company.GeTrialBalanceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.revenues.private.company.GeTrialBalanceResponse}
 */
proto.revenues.private.company.GeTrialBalanceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsInTrial(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTrialBalance(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTrialLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.revenues.private.company.GeTrialBalanceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.revenues.private.company.GeTrialBalanceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.revenues.private.company.GeTrialBalanceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.revenues.private.company.GeTrialBalanceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsInTrial();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getTrialBalance();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getTrialLimit();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional bool is_in_trial = 1;
 * @return {boolean}
 */
proto.revenues.private.company.GeTrialBalanceResponse.prototype.getIsInTrial = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.revenues.private.company.GeTrialBalanceResponse} returns this
 */
proto.revenues.private.company.GeTrialBalanceResponse.prototype.setIsInTrial = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional int64 trial_balance = 2;
 * @return {number}
 */
proto.revenues.private.company.GeTrialBalanceResponse.prototype.getTrialBalance = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.revenues.private.company.GeTrialBalanceResponse} returns this
 */
proto.revenues.private.company.GeTrialBalanceResponse.prototype.setTrialBalance = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 trial_limit = 3;
 * @return {number}
 */
proto.revenues.private.company.GeTrialBalanceResponse.prototype.getTrialLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.revenues.private.company.GeTrialBalanceResponse} returns this
 */
proto.revenues.private.company.GeTrialBalanceResponse.prototype.setTrialLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


goog.object.extend(exports, proto.revenues.private.company);
